import { render, staticRenderFns } from "./FoodDetailPanel.vue?vue&type=template&id=ab19f0a4&scoped=true"
import script from "./FoodDetailPanel.vue?vue&type=script&lang=js"
export * from "./FoodDetailPanel.vue?vue&type=script&lang=js"
import style0 from "./FoodDetailPanel.vue?vue&type=style&index=0&id=ab19f0a4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab19f0a4",
  null
  
)

export default component.exports